import { redirect } from '@utils';
import { buildApiUrl } from '../api/build-url';
import { UseRedirect } from './types';

const useRedirect: UseRedirect = ({ transactionId, setError, success }) => {
  const handleGetRedirect = async () => {
    try {
      let url = buildApiUrl(`/api/v1/deposit/${transactionId}/resultredirect`);

      if (success !== undefined && success !== null) {
        url = `${url}?success=${success}`;
      }

      const response = await fetch(url, {
        redirect: 'manual'
      });

      if (response.type === 'opaqueredirect') {
        redirect(response.url);
        return true;
      }

      return false;
    } catch (err) {
      console.error(err);
      setError(String(err));
      return false;
    }
  };

  return { onGetRedirect: handleGetRedirect };
};

export default useRedirect;
